import React from 'react';
import Button from '@mui/material/Button';
import { Box, TextField, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';

function ModuleTotalHoursButton({
    course,
    colors,
    handlePopOverClose,
    enqueueSnackbar,
    socketConnected,
    socket,
}) {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        bgcolor: colors.primary[600],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    // for modal
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); handlePopOverClose(); };

    // Convert total_minutes to hours and minutes
    const totalMins = course.total_minutes || 0;
    const [hours, setHours] = React.useState(Math.floor(totalMins / 60));
    const [minutes, setMinutes] = React.useState(totalMins % 60);

    const handleHoursChange = (e) => {
        const newValue = parseInt(e.target.value) || 0;
        setHours(newValue);
    };

    const handleMinutesChange = (e) => {
        const newValue = parseInt(e.target.value) || 0;
        setMinutes(newValue);
    };

    React.useEffect(() => {
        if (course && course.total_minutes !== undefined) {
            const totalMins = course.total_minutes || 0;
            setHours(Math.floor(totalMins / 60));
            setMinutes(totalMins % 60);
        }
    }, [course]);

    const handleSave = async () => {
        if (!socketConnected) {
            enqueueSnackbar("Socket is not connected. Please refresh the page.", { variant: "error" });
            return;
        }

        if (isNaN(hours) || isNaN(minutes)) {
            enqueueSnackbar("Hours and Minutes must be valid numbers.", { variant: "error" });
            return;
        }

        if (hours < 0) {
            enqueueSnackbar("Hours cannot be less than 0.", { variant: "error" });
            return;
        }

        if (minutes < 0 || minutes > 59) {
            enqueueSnackbar("Minutes must be between 0 and 59.", { variant: "error" });
            return;
        }

        // Convert to total minutes
        const total_minutes = (hours * 60) + minutes;

        try {
            // emit to server
            socket.emit("put.TotalMinutes", {
                course_id: course.id,
                total_minutes: total_minutes,
            });
        } catch (error) {
            console.error(error);
            enqueueSnackbar("Error: Cannot save Total Course Hours at the moment.", { variant: "error" });
            return;
        }

        handleClose();
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                sx={{
                    p: 1,
                    width: "100%",
                    bgcolor: colors.greenAccent[700],
                    borderRadius: "0px",
                    '&:hover': {
                        bgcolor: colors.greenAccent[600],
                    },
                }}
            >
                Total course hours
            </Button>
            <Modal
                aria-labelledby="total-hours-setup-modal"
                aria-describedby="total-hours-setup-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography variant="h4" color={colors.primary[450]}>
                            Set up Total Course Hours
                        </Typography>
                        <CloseIcon sx={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }} onClick={handleClose} />
                        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 2, mt: 2 }}>
                            <TextField
                                type='number'
                                label="Hours"
                                variant="outlined"
                                value={hours}
                                onChange={(e) => handleHoursChange(e)}
                                sx={{ width: 200, mt: 2 }}
                                inputProps={{ min: 0 }}
                            />
                            <TextField
                                type='number'
                                label="Minutes"
                                variant="outlined"
                                value={minutes}
                                onChange={(e) => handleMinutesChange(e)}
                                sx={{ width: 200, mt: 2 }}
                                inputProps={{ min: 0, max: 59 }}
                            />
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 2,
                                mt: 2,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ width: 200, mt: 2 }}
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                sx={{ width: 200, mt: 2 }}
                                onClick={() => handleClose()}
                            >
                                Close
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

export default ModuleTotalHoursButton
